import { SxProps } from '@mui/material'

interface ErrorBoundaryStyles {
  root: SxProps
  content: SxProps
  title: SxProps
  message: SxProps
}

export const errorBoundaryStyles: ErrorBoundaryStyles = {
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 3,
    bgcolor: 'background.default',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 2,
    maxWidth: 420,
  },
  title: {
    color: 'text.primary900',
  },
  message: {
    color: 'text.secondary700',
  },
}
